import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatDistance } from '@grandvisionhq/utils';
import { getStoreDetailUrl } from '../../utils/store-utils.js';
import 'lodash/deburr';
import { NearbyStores } from './NearbyStores.js';

var NearbyStoresContainer = (_param)=>{
    var { stores: storeData , urls , storeDetails  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "stores",
        "urls",
        "storeDetails"
    ]);
    const { getLabel , distanceUnit , getFormattedLabel  } = useIntl();
    const storeDetailsUrlProvider = React.useMemo(()=>{
        return getStoreDetailUrl((urls === null || urls === void 0 ? void 0 : urls.storeDetails) || '');
    }, [
        urls
    ]);
    const labels = React.useMemo(()=>({
            title: getLabel('stores.component.nearbyStores.title')
        })
    , [
        getLabel
    ]);
    const stores = React.useMemo(()=>{
        return storeData.filter((store)=>{
            return !(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.globalStoreId) || (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.globalStoreId) !== store.globalStoreId;
        }).map((store)=>{
            var ref;
            const storeDetailsUrl = storeDetailsUrlProvider(store);
            const distance = store.distance !== undefined ? formatDistance(store.distance, distanceUnit, {
                separator: ' '
            }) : store.distance;
            var _detailImage, ref1;
            return {
                globalStoreId: store.globalStoreId,
                url: storeDetailsUrl,
                image: (ref1 = (_detailImage = store.detailImage) !== null && _detailImage !== void 0 ? _detailImage : urls === null || urls === void 0 ? void 0 : (ref = urls.storeFallbackImage) === null || ref === void 0 ? void 0 : ref.url) !== null && ref1 !== void 0 ? ref1 : '',
                label: store.shortName,
                distance: getFormattedLabel('stores.component.nearbyStores.distance', {
                    labelData: {
                        distance: distance !== null && distance !== void 0 ? distance : ''
                    }
                })
            };
        });
    }, [
        storeData,
        urls,
        distanceUnit,
        storeDetailsUrlProvider,
        getFormattedLabel,
        storeDetails
    ]);
    const links = React.useMemo(()=>{
        const linksToBeAdded = [];
        if ((storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbName) && (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbSlug)) {
            linksToBeAdded.push({
                label: getFormattedLabel('stores.component.nearbyStores.group', {
                    labelData: {
                        groupName: storeDetails.breadcrumbName
                    }
                }),
                url: storeDetails.breadcrumbSlug
            });
        }
        if (urls === null || urls === void 0 ? void 0 : urls.storeOverview) {
            linksToBeAdded.push({
                label: getLabel('stores.component.nearbyStores.allStores'),
                url: urls.storeOverview
            });
        }
        return linksToBeAdded;
    }, [
        urls,
        getLabel,
        getFormattedLabel,
        storeDetails
    ]);
    return /*#__PURE__*/ React.createElement(NearbyStores, swcHelpers.extends({}, rest, {
        labels: labels,
        stores: stores,
        links: links
    }));
};

export { NearbyStoresContainer, NearbyStoresContainer as default };
//# sourceMappingURL=NearbyStoresContainer.js.map
